module.exports = __webpack_public_path__ + "static/media/resume.3df18859.pdf";